var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
    fill: "#2D264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35173 5.59572C7.92325 4.30899 9.85905 3.25 12 3.25C14.141 3.25 16.0768 4.30899 17.6483 5.59572C19.2284 6.88946 20.5204 8.47865 21.3886 9.68801L21.4602 9.78759C21.9829 10.5138 22.4131 11.1117 22.4131 12C22.4131 12.8883 21.9829 13.4862 21.4602 14.2124L21.3886 14.312C20.5204 15.5214 19.2284 17.1105 17.6483 18.4043C16.0768 19.691 14.141 20.75 12 20.75C9.85905 20.75 7.92325 19.691 6.35173 18.4043C4.77164 17.1105 3.47962 15.5214 2.61142 14.312L2.53981 14.2124C2.01715 13.4862 1.58691 12.8883 1.58691 12C1.58691 11.1117 2.01715 10.5138 2.53981 9.78759L2.61142 9.68801C3.47962 8.47865 4.77164 6.88946 6.35173 5.59572ZM12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.86e9b1cc4148648c66bfff75c1ef0751.svg";
export { ForwardRef as ReactComponent };